import React, { Component } from "react";
import { Spinner, ButtonGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Common from "../../../Common/Common";
import "../Modal.css";
import "./GuideDownload.css";
import MultiSelectModal from "../MultiSelectModal";
import AlertModal from "../AlertModal";
import GuideCard from "./GuideCard";
import SharedInvitations from "./SharedInvitations";
import { notifySharingChanged, getSharingState, onSharingChanged } from "../../../Common/useInvitationCount";
import { splitSharedGuides, applySharingAction, hiddenFromLibrary } from "../../../Common/shareInvites";
import Guide from "../../../Models/Guide";
import User from "../../../Models/User";

import DataBase from "../../../dataBase/liquidGuides";
import { AI_DISCLAIMER, AI_DISCLAIMER_LINK_TEXT, FEEDBACK_URL } from "../../../Common/aiDisclaimer";

const icoAccessLevel = solid("unlock");
const icoFrom = solid("paper-plane");

class GuideDownloadComponent extends Component {
  constructor(props) {
    super(props);
    let mode = this.props.mode;
    let modify_only = this.props.modify_only === "true";
    const AccessRights = [
      // "Featured",
      "Mine",
      "I shared to a few: Read",
      "I shared to a few: Copy",
      "I shared to a few: Modify",
      "I shared to community: Read",
      "I shared to community: Copy",
      "I shared to community: Modify",
      "Shared to me: Read",
      "Shared to me: Copy",
      "Shared to me: Modify",
      "Shared by community: Read",
      "Shared by community: Copy",
      "Shared by community: Modify",
    ];
    let initialAccessRights = [];
    AccessRights.forEach((access) => {
      initialAccessRights.push({
        label: access,
        name: access,
        value: access,
      });
    });
    this.state = {
      visiblePrompt: false,
      category: "",
      add: true,
      defaultCategory: "",
      guides: [],
      guides_unfiltered: [],
      activityIndicator: false,
      Countries: [],
      Cities: [],
      AccessRights: [],
      Country: "All",
      City: "All",
      Access: "All",
      Origin: "All",
      //Origins: [],
      AccessTypes: [],
      SelectedAccess: initialAccessRights,
      MyAccessLevel: "All",
      From: "All",
      FromSenders: [],
      SharedOutLevel: "All",
      To: "All",
      ToRecipients: [],
      mode: mode,
      Language: "All",
      searchText: "",
      modify_only: modify_only,
      AllLanguages: [],

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
      user_info: { uid: this.props.user_info },

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,
    };
  }

  _Country = "All";
  _City = "All";
  //_Access = "Featured";
  _AccessRights = ["All"];
  // Shared-tab-only filters: "my effective access level" (highest of any
  // personal uid:R/C/M + community All_R/C/M grant — see Guide.myAccessLevel)
  // and "who shared this with me" (the guide's owner). Separate from the
  // pre-existing, more granular _AccessRights multiselect above, which isn't
  // wired to any visible button and lists 13 raw category combinations
  // rather than one merged "To me: X" value per guide.
  _MyAccessLevel = "All";
  _From = "All";
  // Mine-tab-only counterparts: "highest access I've granted to anyone else"
  // (Guide.sharedOutLevel) and "who I've shared it with" (a specific
  // recipient uid, not a blanket All_* grant).
  _SharedOutLevel = "All";
  _To = "All";
  //07/26
  //_Language = [];
  _Language = "All";

  AccessChosen = () => {
    if (this.state.SelectedAccess.length === this.state.AccessRights.length) return false;
    return true;
    // if (this.state.SelectedAccess.length > 1) return true;
    // if (this.state.SelectedAccess.findIndex((x) => x.label === "All") === -1) return true;
    // return false;
  };

  LanguageChosen = () => {
    if (this.state.Language.length != this.state.AllLanguages.length) return false;
    return true;
    // if (this.state.Language != "All") return true;
    // return false;
  };

  CountryChosen = () => {
    if (this.state.Country != "All") return true;
    return false;
  };

  CityChosen = () => {
    if (this.state.City != "All") return true;
    return false;
  };

  componentDidMount() {
    //this.setState({ activityIndicator: true });
    //setTimeout(this.timeoutFunc, 5000);
    window.addEventListener("modalOnShow", this.modalOnShow);
    this.modalOnShow();
    // A guide hidden elsewhere (Report this Guide) leaves the lists at once (2026-10-29).
    this._unsubSharing = onSharingChanged((st) => {
      if (!st || st === this._sharingState) return;
      if (this._sharingState) this.onSharingState(st);
      else if (this.props.guide_type === "Featured") this.processGuideInfo(this.state.guides_unfiltered);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("modalOnShow", this.modalOnShow);
    this._unsubSharing?.();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.guide_type !== this.props.guide_type) {
      this.modalOnShow();
    } else if (this.props.guide_type !== "Viewed" && prevProps.guide_info_array !== this.props.guide_info_array) {
      if (this._savingGuides) {
        // This guide_info_array change is OUR OWN save_guides call below
        // reporting back the just-FILTERED (narrowed) list, not an external
        // edit elsewhere in the app. Syncing guides_unfiltered from it here
        // would permanently replace the real full dataset with whatever
        // subset the current filter happened to produce — so the NEXT
        // filter change (e.g. switching "To" from one person to another)
        // would filter that already-narrowed list instead of the true full
        // set, and could easily find nothing. Found 2026-10-01.
        this._savingGuides = false;
        return;
      }
      // A guide was created/modified elsewhere in the same session and the cache
      // was patched in place (see Common.patchGuideInfoEntry) — reflect it in the
      // already-displayed list without a fresh cloud read, even while this panel
      // stays mounted on the same guide_type the whole time.
      this.setState({ guides_unfiltered: this.props.guide_info_array });
      this.processGuideInfo(this.props.guide_info_array, null, true);
    }
  }

  modalOnShow = () => {
    // }
    // componentDidMount() {
    // let Origins = [];
    // ["All", "I Own", "I Shared", "Shared to me", "Community", "Featured"].forEach((access) => {
    //   Origins.push({
    //     label: access,
    //     name: access,
    //     value: access,
    //   });
    // });
    let accessRights = [];

    [
      // "Featured",
      "Mine",
      "I shared to a few: Read",
      "I shared to a few: Copy",
      "I shared to a few: Modify",
      "I shared to community: Read",
      "I shared to community: Copy",
      "I shared to community: Modify",
      "Shared to me: Read",
      "Shared to me: Copy",
      "Shared to me: Modify",
      "Shared by community: Read",
      "Shared by community: Copy",
      "Shared by community: Modify",
    ].forEach((access) => {
      accessRights.push({
        label: access,
        name: access,
        value: access,
      });
    });
    this.setState({ activityIndicator: true, AccessRights: accessRights, guidesRead: false });
    console.log("******componentDidMount");
    if (this.props.guide_type === "Viewed") {
      this.processGuideInfo(this.props.guide_info_array || []);
      this.setState({ activityIndicator: false });
      return;
    }
    if (this.props.guide_type === "Featured") {
      //if (typeof this.props.guide_info_array !== "undefined") {
      if (this.props.guide_info_array.length > 0) {
        this.processGuideInfo(this.props.guide_info_array);
        this.setState({ activityIndicator: false });
        console.log("Guides Cached");
        return;
      }
      //}
    }
    DataBase.getAllGuideInfo(this.props.user_info.uid, this.readAllGuideInfoReturn, this.props.guide_type);
    console.log("Guides NOT Cached");
  };

  readAllGuideInfoReturn = (res) => {
    console.log("readAllGuideInfoReturn", res.pass);
    if (res.pass === false) return;
    let _guides = window.guide_obj.classifyAuthorization(res.res, this.props.user_info.uid);
    //console.log("_guides", _guides);guideInfos.forEach((guide_info) => {
    this.setState({ activityIndicator: false, guides_unfiltered: _guides, guidesRead: true });
    if (res.pass === true) {
      this.processGuideInfo(_guides);
      if (this.props.guide_type === "Shared") this._resolveFromSenders(_guides);
      if (this.props.guide_type === "Mine") this._resolveToRecipients(_guides);
    }
  };

  // Builds the "From" filter's option list — one entry per distinct guide
  // owner across the current Shared results, resolved via the existing
  // one-uid-at-a-time User.findUserByUID (no batching helper exists anywhere
  // in the app; the number of distinct senders in a "shared with me" list is
  // small enough that this is cheap). Falls back to email when a sender
  // never set a name, same convention as UsersDialog.js.
  _resolveFromSenders = (guides) => {
    const distinctUids = [...new Set(guides.map((g) => g.data.user_id).filter(Boolean))];
    if (distinctUids.length === 0) {
      this.setState({ FromSenders: [] });
      return;
    }
    let pending = distinctUids.length;
    const senders = [];
    distinctUids.forEach((uid) => {
      User.findUserByUID(uid, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const label = fullName || (res?.pass === true ? res.res.email : "") || uid;
        senders.push({ label, value: uid, name: uid });
        pending -= 1;
        if (pending === 0) {
          senders.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
          this.setState({ FromSenders: senders });
        }
      });
    });
  };

  selectMyAccessLevel = () => {
    // "All" is a real, selectable option (not just an implicit default) so
    // this single-select filter can be cleared from inside the dialog
    // itself, without needing the global "Clear All" (which would also
    // reset City/Country/Language). Found 2026-10-01.
    const options = ["All", "Read", "Copy", "Modify"].map((level) => ({ label: level, name: level, value: level }));
    this.MultiSelect(options, [this._MyAccessLevel], "uni", this.selectedMyAccessLevel, "To me");
  };

  selectedMyAccessLevel = (selected) => {
    const level = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ MyAccessLevel: level });
    this._MyAccessLevel = level;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectFrom = () => {
    // "All" is a real, selectable option (see selectMyAccessLevel's
    // identical reasoning) so this filter can be cleared on its own.
    const options = [{ label: "All", value: "All", name: "All" }, ...this.state.FromSenders];
    // Preselect the actual matching object (value=uid), not just the stored
    // label — two different senders can resolve to the same display label
    // (e.g. a shared name or the same email-fallback), and matching by label
    // alone would risk pre-checking the wrong person. Found 2026-10-01.
    const currentlySelected = options.find((r) => r.value === this._From) || options[0];
    this.MultiSelect(options, [currentlySelected], "uni", this.selectedFrom, "From");
  };

  selectedFrom = (selected) => {
    const uid = selected.length < 1 ? "All" : selected[0].value;
    const label = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ From: label });
    this._From = uid;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  // Mine-tab counterpart to _resolveFromSenders — one entry per distinct
  // recipient (individually-named uid:R/C/M grants, not blanket All_*)
  // across all of the current user's own guides.
  _resolveToRecipients = (guides) => {
    const distinctUids = [
      ...new Set(
        guides.flatMap((g) => Guide.sharedOutRecipients(g.data.access, this.props.user_info.uid))
      ),
    ];
    if (distinctUids.length === 0) {
      this.setState({ ToRecipients: [] });
      return;
    }
    let pending = distinctUids.length;
    const recipients = [];
    distinctUids.forEach((uid) => {
      User.findUserByUID(uid, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const label = fullName || (res?.pass === true ? res.res.email : "") || uid;
        recipients.push({ label, value: uid, name: uid });
        pending -= 1;
        if (pending === 0) {
          recipients.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
          this.setState({ ToRecipients: recipients });
        }
      });
    });
  };

  selectSharedOutLevel = () => {
    // "All" is a real, selectable option (see selectMyAccessLevel's
    // identical reasoning) so this filter can be cleared on its own.
    const options = ["All", "Not shared", "Read", "Copy", "Modify"].map((level) => ({ label: level, name: level, value: level }));
    this.MultiSelect(options, [this._SharedOutLevel], "uni", this.selectedSharedOutLevel, "Shared");
  };

  selectedSharedOutLevel = (selected) => {
    const level = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ SharedOutLevel: level });
    this._SharedOutLevel = level;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectTo = () => {
    // "All" is a real, selectable option (see selectMyAccessLevel's
    // identical reasoning) so this filter can be cleared on its own.
    const options = [{ label: "All", value: "All", name: "All" }, ...this.state.ToRecipients];
    // Preselect the actual matching object (value=uid), not just the stored
    // label — two different recipients can resolve to the same display
    // label (e.g. a shared name or the same email-fallback), and matching by
    // label alone would risk pre-checking the wrong person. Found 2026-10-01.
    const currentlySelected = options.find((r) => r.value === this._To) || options[0];
    this.MultiSelect(options, [currentlySelected], "uni", this.selectedTo, "To");
  };

  selectedTo = (selected) => {
    const uid = selected.length < 1 ? "All" : selected[0].value;
    const label = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ To: label });
    this._To = uid;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  processGuideInfo = (guideInfos, searchText, skipSaveGuides) => {
    let guides = [];
    console.log("****************processGuideInfo", guideInfos);
    if (searchText == null) searchText = this.state.searchText;
    const searchTextCap = searchText.toUpperCase();
    // Shared shows only accepted guides once the sharing record is loaded;
    // invitations are listed above it (SharedInvitations).
    const acceptedIds =
      this.props.guide_type === "Shared" && this._sharingState
        ? new Set(splitSharedGuides(guideInfos, this.props.user_info?.uid, this._sharingState).accepted.map((g) => g.id))
        : null;
    // Featured leaves out guides the person hid (reported) or whose owner they blocked.
    const hidden = this.props.guide_type === "Featured" ? getSharingState() : null;
    for (let g_i = 0; g_i < guideInfos.length; g_i++) {
      let guide_info = guideInfos[g_i]; //guideInfos.forEach((guide_info) => {
      if (acceptedIds && !acceptedIds.has(guide_info.id)) continue;
      if (hidden && hiddenFromLibrary(guide_info, hidden)) continue;
      //console.log("guide_info.data.categories", guide_info.data.categories);
      //console.log("guide_info.data.language, this._Language", guide_info.data.language, this._Language);
      //console.log("guide_info.data.countries, this._Country", guide_info.data.countries, this._Country);
      if (!Array.isArray(guide_info.data.countries)) guide_info.data.countries = [];
      if (!Array.isArray(guide_info.data.cities)) guide_info.data.cities = [];
      if (!Array.isArray(guide_info.data.categories)) guide_info.data.categories = [];
      // Guides written by mobile (esp. "Mine"'s user_id-merge query — see
      // DataBase.getAllGuideInfo) can be missing these string fields
      // entirely. Unguarded .toUpperCase() below threw a TypeError on any
      // such guide, aborting processGuideInfo before it ever reached the
      // trailing setState — so typing into the library search box silently
      // stopped updating the displayed guide list. Found 2026-09-18.
      if (typeof guide_info.data.guide_name !== "string") guide_info.data.guide_name = "";
      if (typeof guide_info.data.description !== "string") guide_info.data.description = "";
      if (typeof guide_info.data.owner_name !== "string") guide_info.data.owner_name = "";
      if (typeof guide_info.data.guide_id !== "string") guide_info.data.guide_id = "";
      if (typeof guide_info.data.user_id !== "string") guide_info.data.user_id = "";

      if (this.state.modify_only === true) {
        let found = false;
        for (let i = 0; i < guide_info.data.categories.length; i++) {
          if (guide_info.data.categories[i].includes("Modify") || guide_info.data.categories[i].includes("Mine")) {
            found = true;
            break;
          }
        }
        if (found === false) continue;
      }
      if (searchTextCap != "") {
        if (
          !(
            guide_info.data.guide_name.toUpperCase().includes(searchTextCap) ||
            guide_info.data.description.toUpperCase().includes(searchTextCap) ||
            guide_info.data.owner_name.toUpperCase().includes(searchTextCap) ||
            guide_info.data.guide_id.toUpperCase().includes(searchTextCap) ||
            guide_info.data.user_id.toUpperCase().includes(searchTextCap)
          )
        )
          continue;
      }
      //07/26/
      //if (this._Language.length != 0) if (!this._Language.includes(guide_info.data.language)) continue;
      if (guide_info.data.language != this._Language && this._Language != "All") continue;
      if (!guide_info.data.countries.includes(this._Country) && this._Country != "All") continue;
      if (!guide_info.data.cities.includes(this._City) && this._City != "All") continue;
      if (this.props.guide_type !== "Viewed") {
        if (
          !guide_info.data.categories.some((r) => this._AccessRights.indexOf(r) >= 0) &&
          !this._AccessRights.includes("All")
        )
          continue;
        if (this.props.guide_type !== "Featured" && guide_info.data.type === "Featured") continue;
      }
      if (this.props.guide_type === "Shared") {
        const myLevel = Guide.myAccessLevel(guide_info.data.access, this.props.user_info.uid);
        guide_info.data._myAccessLevel = myLevel;
        if (this._MyAccessLevel !== "All" && myLevel !== this._MyAccessLevel) continue;
        if (this._From !== "All" && guide_info.data.user_id !== this._From) continue;
      }
      if (this.props.guide_type === "Mine") {
        const sharedLevel = Guide.sharedOutLevel(guide_info.data.access, this.props.user_info.uid);
        guide_info.data._sharedOutLevel = sharedLevel;
        if (this._SharedOutLevel !== "All") {
          const wantNotShared = this._SharedOutLevel === "Not shared";
          if (wantNotShared && sharedLevel !== null) continue;
          if (!wantNotShared && sharedLevel !== this._SharedOutLevel) continue;
        }
        const recipientsForGuide = Guide.sharedOutRecipients(guide_info.data.access, this.props.user_info.uid);
        // TEMP DEBUG — remove once the "To" AND-like bug is diagnosed.
        if (recipientsForGuide.length > 0) {
          console.log("TEMP To-filter check", JSON.stringify({ guide_name: guide_info.data.guide_name, access: guide_info.data.access, recipientsForGuide, _To: this._To, matches: recipientsForGuide.includes(this._To) }));
        }
        if (this._To !== "All" && !recipientsForGuide.includes(this._To))
          continue;
      }
      guides.push(guide_info);
      //});
    }
    //("this._sort_option", this._sort_option);
    if (this._sort_option === "Name")
      guides = guides.sort((a, b) => ((a.data.guide_name || "").toUpperCase() > (b.data.guide_name || "").toUpperCase() ? 1 : -1));
    else if (this._sort_option === "Rating") guides = guides.sort((a, b) => (a.data.rating < b.data.rating ? 1 : -1));
    else if (this._sort_option === "Times Reviewed")
      guides = guides.sort((a, b) => (a.data.num_ratings < b.data.num_ratings ? 1 : -1));
    else if (this._sort_option === "Times Read")
      guides = guides.sort((a, b) => (a.data.times_read < b.data.times_read ? 1 : -1));
    else if (this._sort_option === "Times Copied")
      guides = guides.sort((a, b) => (a.data.times_copied < b.data.times_copied ? 1 : -1));
    else if (this._sort_option === "Modified date") guides = guides.sort((a, b) => (a.data.mod < b.data.mod ? 1 : -1));
    else if (this._sort_option === "Created date")
      guides = guides.sort((a, b) => (a.data.created < b.data.created ? 1 : -1));
    else if (this._sort_option === "Country")
      guides = guides.sort((a, b) =>
        a.data.countries.join(",").toUpperCase() > b.data.countries.join(",").toUpperCase() ? 1 : -1
      );
    else if (this._sort_option === "City")
      guides = guides.sort((a, b) =>
        a.data.cities.join(",").toUpperCase() > b.data.cities.join(",").toUpperCase() ? 1 : -1
      );
    let _countries = [];
    let _cities = [];
    let _languages = [];

    //let guides_html = "";
    guides.forEach((guide_info) => {
      // let countries_ = guide_info.data.countries.join(", ");
      // let cities_ = guide_info.data.cities.join(", ");
      // guides_html += `<li><a href="https://andiamoplaces.com?id=${guide_info.id}" target="_blank"><span>Travel Guide: ${guide_info.data.guide_name}; Cities: ${cities_}; Countries: ${countries_}</span></a></li>\n`;
      //console.log("guide_info.data.language", guide_info.data.language);
      if (typeof guide_info.data.language != "undefined")
        if (!_languages.includes(guide_info.data.language)) _languages.push(guide_info.data.language);
      if (typeof guide_info.data.countries != "undefined") _countries = _countries.concat(guide_info.data.countries);
      if (typeof guide_info.data.cities != "undefined") _cities = _cities.concat(guide_info.data.cities);
    });
    //console.log("guides_html", guides_html);
    _languages = _languages.sort();
    var languages_set = new Set(_languages);
    _languages = [...languages_set].sort();
    //07/26
    //_languages.unshift("All");
    //console.log("_languages", _languages);
    let languages = [];
    _languages.forEach((language) => {
      languages.push({
        label: language,
        name: language,
        value: language,
      });
    });
    var countries_set = new Set(_countries);
    _countries = [...countries_set].sort();
    // _countries.unshift("All");
    let countries = [];
    _countries.forEach((country) => {
      countries.push({
        label: country,
        name: country,
        value: country,
      });
    });
    var cities_set = new Set(_cities);
    _cities = [...cities_set].sort();
    //_cities.unshift("All");

    let cities = [];
    _cities.forEach((city) => {
      cities.push({
        label: city,
        name: city,
        value: city,
      });
    });

    //console.log("processGuideInfo", guides);
    // skipSaveGuides is set when we're re-deriving state FROM an already-updated
    // guide_info_array prop (see componentDidUpdate) — calling save_guides here would
    // re-dispatch a new array reference and trigger this same update again, looping.
    if (this.props.save_guides !== null && !skipSaveGuides) {
      // See componentDidUpdate's matching check — flags the resulting prop
      // update as self-inflicted so it doesn't get mistaken for an external
      // guide edit and corrupt guides_unfiltered with this filtered subset.
      this._savingGuides = true;
      this.props.save_guides(guides, countries, cities, languages);
    }
    this.setState({
      guides: guides,
      Languages: languages,
      AllLanguages: languages,
      Countries: countries,
      Cities: cities,
    });
  };

  onChangeText = (event) => {
    this.setState({ searchText: event.target.value });
    this.processGuideInfo(this.state.guides_unfiltered, event.target.value);
  };

  cancelTextSearch = () => {
    this.setState({ searchText: "" });
    this.processGuideInfo(this.state.guides_unfiltered, "");
  };

  _attributes = null;
  _guide_id = null;

  selectedGuide = (res) => {
    console.log(res);
  };

  selectGuide = (item) => {
    //console.log("selectGuide", item);
    if (item == null) {
      //console.log("item === null");
      //this.props.onHide();
      return;
    }
    //console.log("item.id", item.id);
    let callback = this.props.callback;
    //console.log("callback", callback);
    if (callback != null)
      callback({ guide_info_id: item.id, guide_id: item.data.guide_id, guide_name: item.data.guide_name });
    //this.props.onHide();
    return;
  };

  readGuideDataReturn = (res) => {
    console.log("readGuideDataReturn", res.guide_id);
    //this.props.onsetActivityIndicator(false);
    // if (res.pass === true) {
    //   let GuideObj = new Guide(this.state.new_guide_id);
    //   const guide_json = res.res.data;
    //   var guide_obj = JSON.parse(guide_json);
    //   const decoded = GuideObj.decodeGuideFb(guide_obj, this._attributes);
    //   if (decoded === true) {
    //     GuideObj.schedule.getPlaces_InSchedule();
    //     this.props.onDownloadGuideFb(res.guide_id, GuideObj.attributes, GuideObj, this._attributes);
    //     let html = "";
    //     this.props.onModifyGuideAttributes(this._attributes);
    //     this.props.onUpdateDocHTML();
    //     this.props.onSetOwnerInfo(res.owner_info);
    //     this.props.onSetCreatorInfo(res.creator_info);

    //     let user_info = JSON.parse(JSON.stringify(this.props.user_info));
    //     user_info.last_guide_id = this._guide_id;
    //     user_info.last_guide_time = DateTime.now().toISO({ zone: "utc" });
    //     this.props.onSetUserInfo(user_info);
    //     console.log("readGuideDataReturn", user_info);
    //     DataBase.updateUser(user_info, this.props.user_info.uid, this.updateUserCallback);
    //     this.setState({ activityIndicator: false });
    //   } else {
    //     this.setState({ activityIndicator: false });
    //   }
    // } else {
    //   this.setState({ activityIndicator: false });
    // }
    // const callback = this.props.navigation.getParam("callback", null);
    // if (callback != null) callback(this._guide_id);
    // this.setState({ activityIndicator: false });
    // this.props.navigation.replace("MainScreen");
    // this.props.navigation.navigate("MainScreen");
  };

  updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };

  // Share invitations (4.10.55) — same as GuideDownload.js: undefined while
  // loading, null when the record can't be used (every shared guide shows,
  // as before), else { accepted, hidden, blocked }.
  _sharingState = undefined;

  onSharingState = (st) => {
    this._sharingState = st;
    if (this.props.guide_type === "Shared") this.processGuideInfo(this.state.guides_unfiltered);
  };

  // Hides a guide someone shared with you; it isn't deleted for its owner.
  removeSharedGuide = (guide_info_id, name) => {
    this.MyAlert("Confirmation", `Remove "${name}" from your Library? It stays with its owner — you just won't see it any more.`, [
      {
        Title: "Remove",
        Method: () => {
          DataBase.sharingAction(this.props.user_info?.uid, "hide", guide_info_id);
          const next = applySharingAction(this._sharingState, "hide", guide_info_id);
          this.onSharingState(next);
          notifySharingChanged(next);
        },
      },
      { Title: "Cancel", Method: null },
    ]);
  };

  MyAlert = (title, message, buttons) => {
    this.setState({
      AlertModalTitle: title,
      AlertModalMessage: message,
      AlertModalButtons: buttons,
      AlertModalShow: true,
    });
  };

  copyFromGuide = (guide_info_id, guide_id) => {};

  deleteGuide = (guide_info_id, guide_id) => {
    if (guide_id === this.props.guide_meta.guide_id) {
      this.setState({ activityIndicator: false });
      this.MyAlert("Message", "Cannot delete guide that you are viewing", [{ Title: "OK", Method: () => null }]);
      return;
    }
    this.MyAlert("Confirmation", "Confirm Delete guide from cloud?", [
      { Title: "OK", Method: () => this.onDeleteOnlineGuide(guide_info_id, guide_id) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  _deleteGuideID = "";
  onDeleteOnlineGuide = (guide_info_id, guide_id) => {
    //selectedAccess("onDeleteOnlineGuide", item);
    this._deleteGuideID = guide_id;
    DataBase.deleteGuideInfo(guide_info_id, this.deleteGuideInfoCallback);
  };

  deleteGuideInfoCallback = (res) => {
    if (res.pass === true) {
      DataBase.deleteGuideData(this._deleteGuideID, this.deleteGuideDataCallback);
    }
  };

  deleteGuideDataCallback = () => {
    this._deleteGuideID = null;
    DataBase.getAllGuideInfo(this.props.user_info.uid, this.readAllGuideInfoReturn, this.props.guide_type);
  };

  guideDetails = (item) => {
    console.log("guideDetails", item);
    // this.props.navigation.navigate("GuideEdit", {
    //   mode: "VIEW",
    //   guideAttributes: item.data,
    //   guide_info_id: item.id,
    // });
  };

  showCountries = (item) => {
    const guideAttributes = item.data;
    let countries = "";
    if (typeof guideAttributes["countries"] != "undefined") countries = guideAttributes["countries"].join(", ");
    return countries;
  };

  showCities = (item) => {
    const guideAttributes = item.data;
    let cities = "";
    if (typeof guideAttributes["cities"] != "undefined") cities = guideAttributes["cities"].join(", ");
    return cities;
  };
  selectLanguage = () => {
    this.MultiSelect(this.state.Languages, [this._Language], "uni", this.selectedLanguage, "Language");
  };

  selectedLanguage = (language) => {
    //7/26let languages = [];
    // language.foreach((lang) => {
    //   languages.push(lang.label);
    // });
    // this.setState({ Language: languages });
    // this._Language = languages;

    if (language.length < 1) {
      this.setState({ Language: "All" });
      this._Language = "All";
    } else {
      this.setState({ Language: language[0].label });
      this._Language = language[0].label;
    }
    //console.log("selectedLanguage", this._Language);

    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectCountry = () => {
    this.MultiSelect(this.state.Countries, [this._Country], "uni", this.selectedCountry, "Country");
  };

  selectedCountry = (country) => {
    if (country.length < 1) {
      this.setState({ Country: "All" });
      this._Country = "All";
    } else {
      this.setState({ Country: country[0].label });
      this._Country = country[0].label;
    }
    //console.log("selectedCountry", this._Country);
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectCity = () => {
    this.MultiSelect(this.state.Cities, [this._City], "uni", this.selectedCity, "City or Place");
  };

  selectedCity = (city) => {
    if (city.length < 1) {
      this.setState({ City: "All" });
      this._City = "All";
    } else {
      this.setState({ City: city[0].label });
      this._City = city[0].label;
    }
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  _sort_option = this.props.guide_sort_option;
  sortBy = () => {
    //console.log("this.state.Cities", this.state.Cities);
    const sort_options = [
      "Name",
      "Rating",
      "Times Reviewed",
      "Times Read",
      //"Times Copied",
      "Modified date",
      "Created date",
    ];
    let sort_options_list = [];
    sort_options.forEach((option) => {
      sort_options_list.push({
        label: option,
        value: option,
      });
    });
    const _selectedItems = [{ label: this._sort_option, value: this._sort_option }];
    //console.log("_selectedItems", _selectedItems);
    this.MultiSelect(sort_options_list, _selectedItems, "uni", this.selectedSortOption, "Sort Option");
  };

  selectedSortOption = (sort_option) => {
    //console.log("sort_option", sort_option);
    if (sort_option.length > 0) this._sort_option = sort_option[0].label;
    this.props.set_guide_sort_option(this._sort_option);
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectAccessRights = () => {
    this.MultiSelect(this.state.AccessRights, this.state.SelectedAccess, "multi", this.selectedAccess, "Access Rights");
  };

  selectedAccess = (access) => {
    //console.log("selectedAccess", access);
    let _access = [];
    this._AccessRights = [];
    access.forEach((ac) => {
      _access.push(ac.label);
      this._AccessRights.push(ac.label);
    });
    //if (_access.includes("All")) _access = ["All"];
    //const Access = access.length === 1 ? access[0].label : "Multiple";
    this.setState({ SelectedAccess: _access });
    //this._AccessRights = _access;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  // selectOrigins = () => {
  //   //selectedAccess("selectOrigins");
  //   this.props.navigation.navigate("MultiSelectDialog", {
  //     selectionList: this.state.Origins,
  //     selectedItems: [this.state.Origin],
  //     callBack: this.selectedOrigin,
  //     mode: "uni",
  //   });
  // };

  // selectedOrigin = (origin) => {
  //   this.setState({ Origin: origin[0].label });
  //   global.Origins = origin[0].label;
  // };

  handleSearchChanged = () => {};

  renderGuideTypeSwitcher = () => {
    if (this.props.mobile_mode !== true || !this.props.on_select_guide_type) return null;
    const activeType = this.props.guide_type || "Mine";
    const hasViewed = this.props.guide_info_array_viewed && this.props.guide_info_array_viewed.length > 0;
    const options = [
      ...(hasViewed ? [{ type: "Viewed", label: "Viewed" }] : []),
      { type: "Mine", label: "My Guides" },
      { type: "Featured", label: "Featured" },
      { type: "Shared", label: "Shared" },
    ];
    return (
      <ButtonGroup style={{ width: "100%" }}>
        {options.map((option) => (
          <Button
            key={option.type}
            variant={activeType === option.type ? "primary" : "outline-primary"}
            onClick={() => this.props.on_select_guide_type(option.type)}
            style={{ flex: 1 }}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    );
  };

  render() {
    let guides_to_display = Common.filterGuides(
      this.state.guides,
      this.props.guide_search_text,
      this.props.guide_countries_selected,
      this.props.guide_cities_selected,
      this.props.guide_language_selected,
      this.props.guide_order_by,
      this.props.guide_order_ascending
    );
    console.log("guides_to_display", guides_to_display.length);
    console.log("this.state.guides", this.state.guides.length);
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );
    else if (this.state.activityIndicator)
      return (
        <div>
          {this.renderGuideTypeSwitcher()}
          <div className="loading">
            <Spinner animation="border" variant="primary" />
          </div>
        </div>
      );
    else
      return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          {this.renderGuideTypeSwitcher()}
          {this.props.guide_type === "Featured" && (
            <p className="gd-ai-disclaimer" data-testid="featured-ai-disclaimer">
              {AI_DISCLAIMER}{" "}
              <a href={FEEDBACK_URL}>
                {AI_DISCLAIMER_LINK_TEXT}
              </a>
            </p>
          )}
          {this.props.guide_type === "Shared" && (
            <div className="gd-filters">
              <button
                className={`gd-filter-btn${this.state.MyAccessLevel !== "All" ? " gd-filter-btn--active" : ""}`}
                onClick={this.selectMyAccessLevel}
                title="Filter by what access you were granted"
              >
                <FontAwesomeIcon icon={icoAccessLevel} />
                <span>{this.state.MyAccessLevel === "All" ? "To me" : `To me: ${this.state.MyAccessLevel}`}</span>
              </button>
              <button
                className={`gd-filter-btn${this.state.From !== "All" ? " gd-filter-btn--active" : ""}`}
                onClick={this.selectFrom}
                title="Filter by who shared it with you"
              >
                <FontAwesomeIcon icon={icoFrom} />
                <span>{this.state.From === "All" ? "From" : `From: ${this.state.From}`}</span>
              </button>
            </div>
          )}
          {this.props.guide_type === "Mine" && (
            <div className="gd-filters">
              <button
                className={`gd-filter-btn${this.state.SharedOutLevel !== "All" ? " gd-filter-btn--active" : ""}`}
                onClick={this.selectSharedOutLevel}
                title="Filter by the access you've granted others"
              >
                <FontAwesomeIcon icon={icoAccessLevel} />
                <span>{this.state.SharedOutLevel === "All" ? "Shared" : `Shared: ${this.state.SharedOutLevel}`}</span>
              </button>
              <button
                className={`gd-filter-btn${this.state.To !== "All" ? " gd-filter-btn--active" : ""}`}
                onClick={this.selectTo}
                title="Filter by who you've shared it with"
              >
                <FontAwesomeIcon icon={icoFrom} />
                <span>{this.state.To === "All" ? "To" : `To: ${this.state.To}`}</span>
              </button>
            </div>
          )}
          <div
            id="PlacesDiv"
            onWheel={(e) => {
              e.currentTarget.scrollTop += e.deltaY;
            }}
            style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
            }}
          >
            <div style={{ width: "100%" }}>
              {/* Also with no guide shared by name, once the list is read: a hidden Featured guide can still be restored. */}
              {this.props.guide_type === "Shared" && (this.state.guides_unfiltered.length > 0 || this.state.guidesRead) && (
                <SharedInvitations
                  uid={this.props.user_info?.uid}
                  guides={this.state.guides_unfiltered}
                  onStateChange={this.onSharingState}
                  onOpen={(g) => this.props.callback(g.id, g.data.guide_id, g.data.guide_name)}
                  confirm={(message, onYes) =>
                    this.MyAlert("Confirmation", message, [
                      { Title: "Block", Method: onYes },
                      { Title: "Cancel", Method: null },
                    ])
                  }
                />
              )}
              {guides_to_display.map((guide, index) => (
                <GuideCard
                  key={index}
                  name={guide.data.guide_name}
                  rating={guide.data.rating}
                  reviews={guide.data.num_ratings}
                  read={guide.data.times_read}
                  language={guide.data.language}
                  countries={guide.data.countries}
                  cities={guide.data.cities}
                  access={guide.data.access_summary}
                  image={guide.data.image}
                  image_m={guide.data.image_m}
                  id={guide.id}
                  callback={this.props.callback}
                  delete_callback={this.deleteGuide}
                  copy_callback={this.props.copy_from_guide}
                  remove_callback={this.props.guide_type === "Shared" && this._sharingState ? this.removeSharedGuide : null}
                  info_callback={this.guideDetails}
                  onHide={null}
                  guide_info={guide.data}
                  guide_info_id={guide.id}
                  mode={"download"}
                  type={"component"}
                  guide_type={this.props.guide_type}
                />
              ))}
            </div>

            <AlertModal
              show={this.state.AlertModalShow}
              onHide={() => this.setState({ AlertModalShow: false })}
              AlertModalTitle={this.state.AlertModalTitle}
              AlertModalMessage={this.state.AlertModalMessage}
              AlertModalButtons={this.state.AlertModalButtons}
            />
          </div>
        </div>
      );
  }
}

export default GuideDownloadComponent;
